import { resolveEnRouteToId } from '@/feature/execution-board/components/TaskTripDetails/TaskTripDetails.utils'
import { TaskProgress } from '@/feature/execution-board/types/taskProgress'

// The location the assigned asset is currently travelling to: the explicit `en_route_to` target
// when the progress payload provides one, otherwise the next remaining stop in order.
export const resolveEnRouteTargetLocationId = (
  progress: TaskProgress | undefined,
): string | null => {
  if (!progress) {
    return null
  }

  const enRouteId = resolveEnRouteToId(progress.locations.enRouteTo)
  if (enRouteId) {
    return enRouteId
  }

  return progress.locations.remaining[0]?.id ?? null
}
